<script>

export default {
  data() {
    return {
      moveable: {
        snappable: true,
        bounds: this.bounds,
        draggable: true,
        throttleDrag: 0,
        startDragRotate: 0,
        throttleDragRotate: 0,
        zoom: 1,
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      },
      transform: undefined
    };
  },
  computed: {
    style() {
      if (!this.transform) {
        return {};
      }

      return {
        transform: this.transform
      };
    }
  },
  watch: {
    x() {
      this.setupTransform();
    },
    y() {
      this.setupTransform();
    },
    bounds(newBounds) {
      this.moveable.bounds = newBounds;
    }
  },
  methods: {
    handleDrag({ target, transform }) {
      // eslint-disable-next-line no-param-reassign
      target.style.transform = transform;
    },
    handleDragEnd({ lastEvent: { transform } = {} }) {
      if (!transform) {
        return;
      }
      const {
        x,
        y
      } = this.$refs.handler.$el.getBoundingClientRect();
      this.$emit('drag-end', { x, y, transform });
    },
    setupTransform() {
      if (this.x != null && this.y != null) {
        this.transform = `matrix(1, 0, 0, 1, 0, 0) translate(${this.x}px, ${this.y}px)`;
      }
    }
  },
  created() {
    this.setupTransform();
  },
  props: {
    bounds: { type: Object },
    x: { type: Number },
    y: { type: Number }
  }
};

</script>

<style lang="scss" scoped>

.draggable-signature {
  width: 150px;
  height: 50px;
  z-index: 1;
  position: absolute;
}

</style>
